<template>
	<div class="index-wrap">
		<div class="index-box">
			<div class="title-box">公司动态</div>
			
			<div class="box box-lr box-pack-between des-box">
				<div class="img-box">
					<img src="../../static/images/banner1.jpg" />
				</div>
				<div class="box box-tb" style="width: 100%;">
					<div class="flex1 box box-lr box-align-center">
						<div>凝心聚力，砥砺前行——合纵伟业2020年会暨颁奖盛典圆满举行</div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2020.01.16</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(9)">详情></div>
					</div>
				</div>
			</div>
			
			<div class="box box-lr box-pack-between des-box">
				<div class="img-box">
					<img src="../../static/images/des8.jpg" />
				</div>
				<div class="box box-tb" style="width: 100%;">
					<div class="flex1 box box-lr box-align-center">
						<div>赢在合纵！决战双十一，有我必胜！</div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2019.11.11</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(8)">详情></div>
					</div>
				</div>
			</div>
			
			<div class="box box-lr box-pack-between des-box">
				<div class="img-box">
					<img src="../../static/images/des6.png" />
				</div>
				<div class="box box-tb" style="width: 100%;">
					<div class="flex1 box box-lr box-align-center">
						<div>星河WORLD三期物业中心举办"物业服务开放日及园区客户恳谈"。</div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2019.8.29</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(7)">详情></div>
					</div>
				</div>
			</div>

			
			<div class="box box-lr  des-box">
				<div class="img-box">
					<img src="../../static/images/des7.png" />
				</div>
				<div class="flex1 box box-tb">
					<div class="flex1 box box-lr box-align-center">
						<div>在烈日炎炎、骄阳似火的6月，合纵的拓展训练如火如荼的拉开了帷幕。</div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2019.6.22</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(6)">详情></div>
					</div>
				</div>
			</div>
			
			<div class="box box-lr box-pack-between des-box">
				<div class="img-box">
					<img src="../../static/images/des1.png" />
				</div>
				<div class="felx1 box box-tb">
					<div class="flex1 box box-lr box-align-center">
						<div>相遇在最美好的年华，相聚在最温暖的合纵,仲夏之月的 生日会－5月金色party如期而至。</div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2019.5.31</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(1)">详情></div>
					</div>
				</div>
			</div>
			
			<div class="box box-lr box-pack-between des-box">
				<div class="img-box">
					<img src="../../static/images/des2.png" />
				</div>
				<div class="felx1 box box-tb">
					<div class="flex1 box box-lr box-align-center">
						<div>2019年01月24日，合纵举行的年会耀眼开幕，合纵的小伙 伴们欢聚一堂共享2019狂欢盛典！ </div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2019.1.24</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(2)">详情></div>
					</div>
				</div>
			</div>
			
			<div class="box box-lr box-pack-between des-box">
				<div class="img-box">
					<img src="../../static/images/des3.png" />
				</div>
				<div class="felx1 box box-tb">
					<div class="flex1 box box-lr box-align-center">
						<div>清凉夏日，春暖花开.在这个适合出游的季节合纵的小伙伴们 展开了一系列的户外拓展活动。</div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2018.5.17</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(3)">详情></div>
					</div>
				</div>
			</div>
			
			<div class="box box-lr des-box">
				<div class="img-box">
					<img src="../../static/images/des4.png" />
				</div>
				<div class="flex1 box box-tb box-pack-end">
					<div class="flex1 box box-lr box-align-center">
						<div>2017年10月9日，合纵伟业Q4季度誓师大会隆重召开。  </div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2017.10.09</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(4)">详情></div>
					</div>
				</div>
			</div>
			
			<div class="box box-lr des-box">
				<div class="img-box">
					<img src="../../static/images/des5.png" />
				</div>
				<div class="flex1 box box-tb box-pack-end">
					<div class="flex1 box box-lr box-align-center">
						<div>2017年5月20日，合纵的小伙伴们惠东两日游。    </div>
					</div>
					<div class="flex1 box box-lr box-align-center">
						<div class="flex1 box box-lr box-pack-start">2017.5.20</div>
						<div class="felx1 box box-lr box-pack-end curtou" @click="toDes(5)">详情></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		mounted() {
			 window.scrollTo(0,0);
		},
		methods: {
			toDes(index) {
				if (index == 1) {
					this.$router.push({
						path: 'Des1'
					})
				} else if (index == 2) {
					this.$router.push({
						path: 'Des2'
					})
				} else if (index == 3) {
					this.$router.push({
						path: 'Des3'
					})
				} else if (index == 4) {
					this.$router.push({
						path: 'Des4'
					})
				} else if (index == 5) {
					this.$router.push({
						path: 'Des5'
					})
				} else if (index == 6) {
					this.$router.push({
						path: 'Des6'
					})
				} else if (index == 7) {
					this.$router.push({
						path: 'Des7'
					})
				} else if (index == 8) {
					this.$router.push({
						path: 'Des8'
					})
				} else if (index == 9) {
					this.$router.push({
						path: 'Des9'
					})
				}
				
			}
		}
	}
</script>

<style lang="less" scoped>
	.index-wrap {
		width: 100%;
		height: 100%;
		.index-box {
			width: 960px;
			margin: 50px auto 0;
			
			box-sizing: border-box;
			.title-box {
				font-size: 20px;
				color: #000000;
				font-weight: bold;
				padding-bottom: 20px;
				border-bottom: 1px solid #e9e9e9;
			}
			.des-box {
				margin-top: 20px;
				padding-bottom: 20px;
				border-bottom: 1px solid #E9E9E9;
				.curtou {
					cursor: pointer;
				}
				&:last-child {
					border-bottom: 0;
				}
				.img-box {
					margin-right: 20px;
					img {
						width: 412px;
						height: 273px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/More.vue